<template>
    <modal ref="modal" :modal-backdrop="true">
        <template #body>
            <div class="text-center">
                <div class="text-gray-700 text-lg">Você tem uma consulta agendada nesse horário</div>
                <div class="border border-gray-300 my-4 p-4 rounded-md text-left">
                    <div class="font-bold text-gray-600">Paciente: {{ appointmentStore.modal_appointment.patient.user.name }}</div>
                    <div>{{ appointmentStore.modal_appointment.patient.cpf }}</div>
                </div>
                <button type="button" class="btn-primary-invert font-normal uppercase" @click.prevent="close">Fechar</button>
                <button type="button" class="btn-primary font-normal uppercase ml-1" @click.prevent="confirm">Entrar na consulta</button>
            </div>
        </template>
    </modal>
</template>
<script>
import { ref, watch } from 'vue';
import Modal from '@/Shared/Modal/Modal'
import { useAppointmentStore } from '@/Store/Appointment'

export default {
    components: {
        Modal,
    },
    data() {
        return {
            appointmentStore: useAppointmentStore(),
        }
    },
    setup(props, context) {
        const modal = ref(null);

        const appointmentStore = useAppointmentStore();

        watch(
            () => appointmentStore.modal_appointment,
            () => {
                if(appointmentStore.modal_appointment?.id) {
                    modal.value.showModal = true;
                }
            },
        );

        return {
            modal,
        }
    },
    methods: {
        confirm() {
            this.$refs.modal.showModal = false;
            this.$inertia.visit(`/patients/detail/${this.appointmentStore.modal_appointment.patient.id}/${this.appointmentStore.modal_appointment.id}`);
        },
        close() {
            this.$refs.modal.showModal = false;
            this.appointmentStore.setModalAppointment(null);
        }
    },
}
</script>
<style>

</style>